{
	"title": "Přehled open-source softwaru",
	"backTitle": "Zpět"
}
